import { gql } from '@apollo/client';

export const PropertyCardFragment = gql`
  fragment PropertyCardFragment on OdProtosBuyerData_Property {
    id
    addressId
    paramsId
    bedrooms
    bathroomsTotal
    totalLivingSqFt
    currentListPrice
    publishedAt
    street
    city
    state
    badges
    openHouses {
      startsAt
    }
    photos {
      urls {
        size768x512
      }
    }
    thumbnailLegalText
    thumbnailLegalLogo
    listPrice: currentListPrice
    latitude
    longitude
    soldAt
    soldPrice
    yearBuilt
    isFavorite
    postalCode
    currentListingState
    lotSqft
    poolType
    mlsName
  }
`;
